import { render } from "./CurrentAffairsPage.vue?vue&type=template&id=493bfd1a&scoped=true"
import script from "./CurrentAffairsPage.vue?vue&type=script&lang=js"
export * from "./CurrentAffairsPage.vue?vue&type=script&lang=js"

import "./CurrentAffairsPage.vue?vue&type=style&index=0&id=493bfd1a&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493bfd1a"]])

export default __exports__